import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: ''
  });
  const names = ['Valentina', 'Camila', 'Sofía', 'Luciana', 'Martina', 'Isabella', 'Daniela', 'Gabriela', 'Fernanda', 'Andrea', 'Paula', 'Natalia', 'Alejandra', 'Mariana', 'Catalina'];
  const locations = ['Buenos Aires, Argentina', 'Bogotá, Colombia', 'Lima, Perú', 'Santiago, Chile', 'Montevideo, Uruguay', 'Quito, Ecuador', 'Madrid, España', 'Barcelona, España', 'Medellín, Colombia', 'Córdoba, Argentina', 'Rosario, Argentina', 'Guadalajara, México', 'Caracas, Venezuela', 'Asunción, Paraguay'];
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentBuyer({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showPopup, 5000);
    const intervalId = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * (25000 - 15000 + 1) + 15000);
      setTimeout(showPopup, randomDelay);
    }, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalId);
    };
  }, []);
  return <AnimatePresence data-id="element-160">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -50
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -50
    }} transition={{
      duration: 0.5,
      type: 'spring',
      stiffness: 100
    }} className="fixed bottom-4 left-4 z-50 bg-white border border-[#3D2B1F]/10 rounded-2xl p-4 shadow-2xl max-w-sm flex items-start gap-4" data-id="element-161">
          <div className="bg-green-50 p-2 rounded-full shrink-0" data-id="element-162">
            <CheckCircle2Icon className="w-6 h-6 text-green-500" data-id="element-163" />
          </div>
          <div data-id="element-164">
            <p className="text-[#3D2B1F] text-sm md:text-base font-medium leading-tight mb-1" data-id="element-165">
              <span className="font-bold text-[#C67B30]" data-id="element-166">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.location} acaba de comprar este producto.
            </p>
            <p className="text-xs text-[#9C8578] flex items-center gap-1" data-id="element-167">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-168"></span>
              Compra verificada
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}